var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBobaAvatar6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4535200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.2469 40.9306C32.5326 40.9306 41.6814 31.7938 41.6814 20.5229C41.6814 9.25206 32.5326 0.115234 21.2469 0.115234C9.96131 0.115234 0.8125 9.25206 0.8125 20.5229C0.8125 31.7938 9.96131 40.9306 21.2469 40.9306Z",
    fill: "#D66386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.6758 21.1317C28.2689 20.9662 24.4111 17.6853 32.5186 6.63867C32.5186 6.63867 42.0727 7.75236 41.5604 20.319C41.6206 20.319 38.1847 25.0297 28.6758 21.1317Z",
    fill: "#CA2E52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.7477 9.55663C36.3741 8.08061 34.5322 7.12367 32.5336 6.84766C31.5992 8.14195 30.1375 10.6402 29.5196 11.7238C29.4895 11.7238 36.964 12.6268 37.7477 9.55663Z",
    fill: "#6C8646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.6254 25.646C15.1883 25.646 10.7579 23.1326 16.4542 10.6864C16.4542 10.6864 25.496 9.91882 28.6455 21.4621C28.6455 21.4621 25.722 27.5423 15.6254 25.646Z",
    fill: "#CA2E52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.1202 12.2224C20.4771 11.0556 18.4807 10.492 16.4691 10.6271C15.806 12.1321 14.9621 14.811 14.4648 16.015C14.4648 16.015 21.9695 15.3829 22.1202 12.2224Z",
    fill: "#6C8646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.0957 24.4838C25.9601 24.0624 25.9601 19.0056 39.6584 18.0273C39.6584 18.0273 44.6917 25.5523 36.0417 33.8899C36.0266 33.8899 29.2754 34.2361 26.0957 24.4838Z",
    fill: "#CA2E52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.0001 23.719C41.2382 21.7186 40.7749 19.6977 39.6891 18C38.0917 18.1204 35.1682 18.6321 34.0078 18.8428C34.0078 18.8428 38.152 25.1035 41.0001 23.719Z",
    fill: "#6C8646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M20.6562 39.5796C20.1288 39.5796 14.6283 37.2318 19.8274 22.0314C19.8274 22.0314 30.3761 20.0599 35.3341 33.1533C35.3341 33.1533 32.6366 40.5879 20.6562 39.5796Z",
    fill: "#CA2E52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.5927 23.1431C24.5384 21.9897 22.1499 21.5753 19.8265 21.9692C19.2237 23.7451 18.4702 27.041 18.1387 28.4858C18.1387 28.4858 26.8037 26.8604 26.5927 23.1431Z",
    fill: "#6C8646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M8.36455 17.3671C10.5701 17.3671 12.358 15.5815 12.358 13.3789C12.358 11.1762 10.5701 9.39062 8.36455 9.39062C6.15903 9.39062 4.37109 11.1762 4.37109 13.3789C4.37109 15.5815 6.15903 17.3671 8.36455 17.3671Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.3216 11.1229C23.5271 11.1229 25.315 9.33735 25.315 7.13471C25.315 4.93207 23.5271 3.14648 21.3216 3.14648C19.1161 3.14648 17.3281 4.93207 17.3281 7.13471C17.3281 9.33735 19.1161 11.1229 21.3216 11.1229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M20.3289 10.4012C21.9269 10.4012 23.2223 9.10752 23.2223 7.51165C23.2223 5.91578 21.9269 4.62207 20.3289 4.62207C18.731 4.62207 17.4355 5.91578 17.4355 7.51165C17.4355 9.10752 18.731 10.4012 20.3289 10.4012Z",
    fill: "#BB2A46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.25079 16.0292C10.8488 16.0292 12.1442 14.7355 12.1442 13.1396C12.1442 11.5437 10.8488 10.25 9.25079 10.25C7.65283 10.25 6.35742 11.5437 6.35742 13.1396C6.35742 14.7355 7.65283 16.0292 9.25079 16.0292Z",
    fill: "#BB2A46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M16.3196 24.9071C16.5155 24.5008 17.1936 19.5042 3.78163 16.6748C3.78163 16.6748 -2.57775 23.5376 6.52432 33.4103C6.47911 33.4103 11.7987 34.1327 16.3196 24.9071Z",
    fill: "#CA2E52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M1.61133 22.1266C1.65067 20.1156 2.38541 18.1801 3.69092 16.6484C5.19789 16.9795 8.00085 17.8675 9.20642 18.2437C9.20642 18.2437 4.26359 23.9025 1.61133 22.1266Z",
    fill: "#6C8646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M22.4784 29.6759C22.4784 29.2244 20.866 23.6559 7.40875 26.4552C7.40875 26.4552 3.74683 38.1339 19.7207 40.0001C19.7508 39.955 22.0414 39.9098 22.4784 29.6759Z",
    fill: "#CA2E52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M7.64985 32.2975C6.889 30.435 6.7932 28.3678 7.37858 26.4431C8.88555 26.1271 11.8995 25.8562 13.09 25.7207C13.09 25.7207 10.7693 32.8845 7.64985 32.2975Z",
    fill: "#6C8646"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBobaAvatar6);
export default __webpack_public_path__ + "static/media/boba-avatar-6.ec4a4f49.svg";
export { ForwardRef as ReactComponent };